import gql from "graphql-tag";
import { ApolloError } from "@apollo/client";
import { useQuery } from "@apollo/react-hooks";
import { ShippingMethodDetails, AddressFilter } from "src/types/graphql.d";
import { Iso2LetterLocale } from "src/lib/Intl";
import { getIsAddressValid } from "src/utils/validationSchema";
import { Address } from "src/types/forms";

interface ShippingMethodDetailsVars {
  filter: AddressFilter;
  country: Iso2LetterLocale;
}

interface ShippingMethodDetailsHook {
  data: ShippingMethodDetailsQueryResponse | undefined;
  loading: boolean;
  error: ApolloError | undefined;
}

interface ShippingMethodDetailsQueryResponse {
  shippingMethodDetails: ShippingMethodDetails;
}

export const GET_SHIPPING_METHOD_DETAILS = gql`
  query shippingMethodDetails($filter: AddressFilter!) {
    shippingMethodDetails(filter: $filter) {
      pudos {
        name
        value
      }
    }
  }
`;

const useShippingMethodDetails = ({
  filter,
  country,
}: ShippingMethodDetailsVars): ShippingMethodDetailsHook => {
  const { error, data, loading } = useQuery<ShippingMethodDetailsQueryResponse>(
    GET_SHIPPING_METHOD_DETAILS,
    {
      variables: {
        filter,
      },
      ssr: false,
      fetchPolicy: "cache-and-network",
      skip:
        !["NL", "FR", "DE", "BE", "DK", "SE"].includes(country) ||
        !getIsAddressValid(filter as Address),
    }
  );

  return { error, data, loading };
};

export { useShippingMethodDetails };
